import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import { StackActions } from '@react-navigation/native';
import { Background } from 'LocalGluons';
import EpgContainer from 'LocalGluons/components/EpgContainer';
import { useStore } from 'Store';
import { logEvent } from 'AppManager';
import { useNavigationPropsContext } from '../../Navigation/navigationPropsContext';

const HOUR_IN_MS = 1000 * 60 * 60;

const defaultStyles = StyleSheet.create({
    container: {
        paddingTop: 0
    }
});

const Epg = ({ navigation, route }) => {
    const { setPlayerData } = useStore();
    const currentHour = new Date();
    const midnight = new Date().setHours(0, 0, 0, 0);
    const from = midnight + Number(currentHour) * HOUR_IN_MS;
    const to = from + HOUR_IN_MS;
    const { updateNavigationProps } = useNavigationPropsContext();

    return (
        <Background style={defaultStyles.container}>
            <EpgContainer
                navigation={navigation}
                route={route}
                onSelectChannel={(item) => {
                    setPlayerData({ item });
                }}
                onSelectProgram={(item, channel) => {
                    updateNavigationProps({ item });
                    navigation.navigate('Details', {
                        id: item.data.id,
                        type: item.modelType,
                        lowLatency: channel?.lowLatency
                    });
                }}
                fromToInterval={{ from, to }}
            />
        </Background>
    );
};

Epg.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default Epg;
